import { render, staticRenderFns } from "./CreateTariffCoefficient.vue?vue&type=template&id=6dab15ed"
import script from "./CreateTariffCoefficient.vue?vue&type=script&lang=js"
export * from "./CreateTariffCoefficient.vue?vue&type=script&lang=js"
import style0 from "./CreateTariffCoefficient.vue?vue&type=style&index=0&id=6dab15ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports